export abstract class BaseService {

  protected constructor() { }
  
  protected handleError(error: Error): void {
    const name = this.constructor.name;
    console.error(`Error encountered in ${name}: ` + error);
  }

}
